const CheckAndRemoveClasses = () => {
    const ctaContainer = document.querySelector(".final-cta.light");
    const newsletter = document.querySelector(".newsletter");
    if (ctaContainer && newsletter) {
      if (newsletter.classList.contains("dark")) {
        newsletter.classList.remove("dark");
      }
      
      if (newsletter.classList.contains("dark-blue-90")) {
        newsletter.classList.remove("dark-blue-90");
      }
    }
  };
  
  export default CheckAndRemoveClasses;